import React from 'react'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { assert } from 'lib/errors'
import { getPreventNavigationElement } from 'lib/helpers'

import PageVisibility from 'react-page-visibility'

class AppVersionHandler extends React.Component {
    handler

    componentDidMount () {
        this.handler = window.__mv_appVersionHandler
        assert(this.handler)

        this.handler.fetchVersionAndReloadIfChanged()
    }

    handleVisibilityChange = (visible) => {
        if (visible && !getPreventNavigationElement()) {
            // do version check every time user returns to the app from other window of focus or tab
            this.handler.fetchVersionAndReloadIfChanged()
        }
    }

    render () {
        return <PageVisibility onChange={this.handleVisibilityChange} />
    }
}

export default withErrorBoundaryNoRender(AppVersionHandler)
